import mapMailTemplates from './map-mail-templates';

export {
  mapMailTemplates
}
